import { useEffect, useRef } from "react";
import gsap from "gsap";
import Spinner from "../../../shared/components/ui/Spinner";
import { EDITOR_SEND_REASON_LABELS } from "../constants";

export default function EditorSendsTab({ editorSendsStats, showRain }) {
  const cardsRef = useRef([]);
  const animDone = useRef(false);

  useEffect(() => {
    if (editorSendsStats && cardsRef.current.length && !animDone.current) {
      gsap.fromTo(
        cardsRef.current.filter(Boolean),
        { opacity: 0, y: 20 },
        { opacity: 1, y: 0, duration: 0.4, stagger: 0.05, ease: "power2.out" }
      );
      animDone.current = true;
    }
  }, [editorSendsStats]);

  if (!editorSendsStats) {
    return (
      <div className="stats-loading-section">
        <Spinner size="md" />
        Loading editor sends data...
      </div>
    );
  }

  return (
    <div className="editor-sends-grid">
      {/* Summary cards */}
      <div className="stat-cards-grid">
        <div className="stat-card total" ref={(el) => (cardsRef.current[0] = el)}>
          <span className="stat-value">{editorSendsStats.total || 0}</span>
          <span className="stat-label">Total Sent</span>
        </div>
      </div>

      {/* By reason breakdown */}
      <div className="stats-subsection">
        <h3>By Reason</h3>
        {editorSendsStats.by_reason?.length > 0 ? (
          <div className="reason-bars">
            {editorSendsStats.by_reason.map((r) => {
              const pct = editorSendsStats.total
                ? ((r.count / editorSendsStats.total) * 100).toFixed(1)
                : 0;
              return (
                <div key={r.reason} className="reason-row">
                  <div className="reason-label">
                    {EDITOR_SEND_REASON_LABELS[r.reason] || r.reason}
                  </div>
                  <div className="reason-bar-container">
                    <div className="reason-bar" style={{ width: `${pct}%`, background: "#ff7eb3" }} />
                  </div>
                  <div className="reason-count">
                    {r.count} ({pct}%)
                  </div>
                </div>
              );
            })}
          </div>
        ) : (
          <div className="no-data">No sends recorded yet</div>
        )}
      </div>

      {/* Recent sends */}
      <div className="stats-subsection">
        <h3>Recent Sends</h3>
        {editorSendsStats.recent?.length > 0 ? (
          <div className="stats-list">
            {editorSendsStats.recent.map((send) => (
              <div key={send.id} className="stats-list-item">
                <span className="item-name">{send.image_id?.slice(0, 8)}...</span>
                <span className="item-meta">{send.reason?.replace(/_/g, " ")}</span>
                <span className="item-value">
                  {send.sent_at ? new Date(send.sent_at).toLocaleString() : "-"}
                </span>
              </div>
            ))}
          </div>
        ) : (
          <div className="no-data">No recent sends</div>
        )}
      </div>
    </div>
  );
}
